<template>
    <FormInputContainer class="FormCurrency" :inputId="`I${_uid}`" :label="label" :errors="errors">
        <currency-input
            :id="`I${_uid}`"
            v-bind="$attrs"
            :value="value ? value : null"
            v-on="{ [lazy ? 'change' : 'input']: handleInput }"
            placeholder="$0.00"

            currency="USD"
            locale="en-US"
            :distraction-free="false"
            :value-range="{ min, max }"
            :value-as-integer="true"
        />
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormCurrency',
    inheritAttrs: false,

    components: { FormInputContainer },

    props: {
        value: { type: Number },
        label: { type: String },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
        min: { type: Number, default: undefined },
        max: { type: Number, default: undefined },
    },

    methods: {
        handleInput(event) {
            this.$emit('input', event);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.FormCurrency {
    input {
        @extend %form-control;
        padding-right: 10px;
    }
}
</style>
